<template>
    <main-content>
        <div class="shadow-sm rounded p-4">
            <charge-form :form_data="form_data"
                         :form_meta_data="form_meta_data"
                         :on_submit="chargeByOauth"
            >
            </charge-form>
        </div>
    </main-content>
</template>

<script>
    import ChargeForm from './components/charge-by-oauth-form';
    import mainContent from '@/components/main-content';
    import {i18n} from '@/plugins/i18n';
    import $ from 'jquery';
    import {walletService} from '@/common/api.service';

    export default {
        components: {
            ChargeForm,
            mainContent,
        },
        data() {
            return {
                form_data: {
                    amount: '',
                },
                form_meta_data: {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('wallets.label.charge'),
                },
            };
        },
        methods: {
            chargeByOauth() {
                let form = $('#submit_form');

                form.validate({
                    rules: {
                        amount: {
                            required: true,
                        },
                    }
                });

                if (!form.valid()) {
                    return;
                }

                this.form_meta_data.submit_btn_progress = true;

                let params = {
                    amount: this.form_data.amount,
                };

                walletService.chargeByOauthAyande(params, this.$route.params.hashid).then(response => {
                    window.location = response.data.data.oauth_url;
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                }).finally(() => {
                    this.form_meta_data.submit_btn_progress = false;
                });
            },
        },
    }
</script>
